import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getValueByLanguage } from '../hooks/useLocalization';
import { Icon } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ClearIcon from '@mui/icons-material/Clear';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

const WorkPage = ({ images, text }) => {
  const { language } = useSelector((state) => state.config);
  const [activeImage, setActiveImage] = useState(0);
  const [activateImageModal, setActivateImageModal] = useState(false);

  const localized_works = (translateObj, key) => {
    return getValueByLanguage(translateObj, key, language);
  };

  const isVideo = (url) => {
    const videoExtensions = ['mp4', 'webm', 'ogg', 'mov'];
    const extension = url.split('.').pop();
    return videoExtensions.includes(extension);
  };

  const getFileExtension = (url) => {
    return url.split('.').pop().split(/\#|\?/)[0];
  };

  const imagesTmlt = useMemo(() => {
    if (images.length > 0) {
      return images
        .map((img, ind) => {
          return !isVideo(img.full_image_url) ? (
            <div className="grid__image__wrapper" key={img.full_image_url}>
              <img
                className="grid__image"
                src={img.full_image_url}
                data-type="image"
                data-ind={ind}
                alt=""
              />
            </div>
          ) : (
            <div className="grid__image__wrapper" key={img.full_image_url}>
              <div className="img__thumbnail">
                <PlayCircleOutlineIcon className="material-icons" />
              </div>
              <img
                className="grid__image"
                src={img.thumbnail}
                data-ind={ind}
                data-type="video"
                data-extension={getFileExtension(img.full_image_url)}
                data-src={img.full_image_url}
                alt=""
              />
            </div>
          );
        })
        .filter((el) => !!el);
    } else {
      return [];
    }
  }, [images]);

  const images_template = useMemo(() => {
    const categoryImgColClass = text.description
      ? 'works__container__images'
      : 'works__container__images works__container__images_fullWidth';
    if (images.length > 0) {
      return <div className={categoryImgColClass}>{imagesTmlt}</div>;
    }
  }, [text, imagesTmlt]);

  const categoryText = useMemo(() => {
    return text.description ? (
      <div className="works__container__text">
        <div
          dangerouslySetInnerHTML={{
            __html: localized_works(text, 'description'),
          }}
        />
      </div>
    ) : (
      ''
    );
  }, [text]);

  const goToPrevious = () => {
    if (activeImage + 1 === images.length) {
      setActiveImage(0);
    } else {
      setActiveImage(Number.parseInt(activeImage) + 1);
    }
  };

  const goToNext = () => {
    if (activeImage - 1 === -1) {
      setActiveImage(() => Number.parseInt(images.length) - 1);
    } else {
      setActiveImage(() => Number.parseInt(activeImage) - 1);
    }
  };

  useEffect(() => {
    if (!activateImageModal) {
      return;
    }
    const overlayImage = document.getElementsByClassName('overlay__image')[0];
    const overlayVideo = document.getElementsByClassName('overlay__video')[0];

    if (isVideo(images[activeImage].full_image_url)) {
      overlayImage.style.display = 'none';
      overlayVideo.style.display = 'flex';
      hideImageShowVideo();
    } else {
      overlayImage.style.display = 'flex';
      overlayVideo.style.display = 'none';
      hideVideoShowImage();
    }
  }, [activeImage]);

  const hideImageShowVideo = () => {
    document.getElementById('active__image').style.display = 'none';
    document.getElementById('active__video').style.display = 'block';
    document.getElementById('active__video').src =
      images[activeImage].full_image_url;
    document.getElementById('active__image_video_caption').innerHTML = images[
      activeImage
    ].caption
      ? images[activeImage].caption
      : '';
    document.getElementById('active__video__element').type =
      `video/${getFileExtension(images[activeImage].full_image_url)}`;
    document.getElementsByClassName('nav')[0].style.backgroundColor =
      'transparent';
  };

  const hideVideoShowImage = () => {
    document.getElementById('active__image').style.display = 'block';
    document.getElementById('active__video').style.display = 'none';
    document.getElementById('active__video').pause();
    document.getElementById('active__video').currentTime = 0;
    document.getElementById('active__image_video_caption').innerHTML = images[
      activeImage
    ].caption
      ? images[activeImage].caption
      : '';
    document.getElementById('active__image').src =
      images[activeImage].full_image_url;
    document.getElementsByClassName('nav')[0].style.backgroundColor = '#ededed';
  };

  const closeImageModal = (e) => {
    setActivateImageModal(false);

    document.getElementById('active__video').pause();
    document.getElementById('active__video').currentTime = 0;
    const overlayImage = document.getElementsByClassName('overlay__image')[0];
    const overlayVideo = document.getElementsByClassName('overlay__video')[0];
    overlayImage.style.display = 'none';
    overlayVideo.style.display = 'none';
    document.getElementsByClassName('nav')[0].style.backgroundColor = '#ededed';
    const imageModal = document.getElementById('active__image__modal');
    imageModal.style.display = 'none';
  };

  const openImageModal = (el, index) => {
    setActivateImageModal(true);
    setActiveImage(index);

    const overlayImage = document.getElementsByClassName('overlay__image')[0];
    const overlayVideo = document.getElementsByClassName('overlay__video')[0];
    const imageModal = document.getElementById('active__image__modal');
    imageModal.style.display = 'flex';

    if (el.dataset.type === 'video') {
      overlayImage.style.display = 'none';
      overlayVideo.style.display = 'flex';
      hideImageShowVideo();
    } else {
      overlayImage.style.display = 'flex';
      overlayVideo.style.display = 'none';
      hideVideoShowImage();
    }
  };

  useEffect(() => {
    const gridImages = document.querySelectorAll('.grid__image__wrapper img');
    const closeIcon = document.getElementById('close__modal__button');

    gridImages.forEach((el, index) => {
      el.addEventListener(
        'click',
        openImageModal.bind(this, el, el.getAttribute('data-ind')),
      );
    });

    closeIcon.addEventListener('click', closeImageModal.bind());
  }, [images_template]);

  return (
    <>
      <div className="overlay__image" />
      <div className="overlay__video" />
      <div id="active__image__modal">
        <div
          id="modal__image__video__content"
          className="modal__image__video__content"
        >
          <img id="active__image" src="" alt="" />
          <video id="active__video" controls>
            {' '}
            <source id="active__video__element" src="" type="" />{' '}
          </video>
          <div id="active__image_video_caption" />
        </div>
        <div id="prev_next_buttons">
          <button id="prev__button" onClick={goToPrevious} type="button">
            <ArrowBackIosNewIcon className="material-icons">
              arrow_back
            </ArrowBackIosNewIcon>
          </button>
          <button id="next__button" onClick={goToNext} type="button">
            <ArrowForwardIosIcon className="material-icons">
              arrow_forward
            </ArrowForwardIosIcon>
          </button>
          <button
            type="button"
            id="close__modal__button"
            style={{
              cursor: 'pointer',
              zIndex: '52',
              transform: 'translate(-60%, -20%)',
            }}
          >
            <ClearIcon className="material-icons">close</ClearIcon>
          </button>
        </div>
      </div>
      <div className="page-works">
        <div className="works__header">
          {' '}
          <h2>{text.title}</h2>{' '}
        </div>
        <div className="works__grid__container">
          {categoryText}
          {images_template}
        </div>
      </div>
    </>
  );
};
export default WorkPage;
